/** API responses cached by the service worker (Workbox runtime cache, see vite.config.ts). */

/** Workbox runtime cache of `GET /api/*` (same name as in vite.config.ts). */
export const API_CACHE_NAME = 'api-get';

/**
 * Drops the API responses cached by the service worker: at login and logout, so that a tablet
 * shared between users never shows the previous user's data offline.
 */
export async function clearApiCache(): Promise<void> {
  if (typeof caches === 'undefined') return;
  try {
    await caches.delete(API_CACHE_NAME);
  } catch {
    // storage blocked: nothing cached either
  }
}
